import { useCallback, useEffect } from "react";
import Cookies from "js-cookie";
import { fcmGetMessage, fcmGetToken } from "Helpers/fcmKit";
import PropTypes from "prop-types";
import fetchFcmRegister from "../../helpers/http/register";
import generateDeviceId from "../../helpers/generateAgent";
import checkLoginStatus from "../../helpers/checkLogin";
import useNotification from "../../globalStore/notification";
import firebase from "../../firebase";

const FcmNotification = ({ ...props }) => {

	// Fungsi helper untuk delay
	const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	// register only once & send to be
	const registerFcmToken = useCallback((messaging) => {

		fcmGetToken(messaging, props.isMobile, async (fcmToken) => {

			if (!fcmToken) return;
			const oldPlatform = "fds";
			const jwtToken = Cookies.get("token") || "";
			const username = Cookies.get("usrname");
			const deviceId = Cookies.get("device_id");
			const storedFcmToken = Cookies.get("fcm_tkn");
			const persistentId = Cookies.get("perssitent_id");
			const platform = deviceId?.match(/-\d+-([a-z0-9-]+)$/);
			const currentPlatform = platform?.[1] || "";

			let persistentDeviceId = persistentId;

			const notifyServiceWorkerWithPlatformId = () => {

				const idPlatform = Cookies.get("platform_id");
				if ("serviceWorker" in navigator && idPlatform) {

					navigator.serviceWorker.ready.then((registration) => {

						if (registration.active) {

							registration.active.postMessage({ idPlatform });

						}

					});

				}

			};

			// Generate persistent ID jika belum ada
			if (jwtToken && !persistentDeviceId) {

				persistentDeviceId = generateDeviceId(username, false, oldPlatform);
				Cookies.set("perssitent_id", persistentDeviceId, {
					domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "net" : "com"}`,
				});
				Cookies.set("platform_id", oldPlatform, {
					domain: `.femaledaily.${
						process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "net" : "com"
					}`,
				});
				// Inform service worker setelah set cookie
				notifyServiceWorkerWithPlatformId();
				await delay(500);

			}

			const newDeviceId = generateDeviceId(
				username,
				persistentDeviceId,
				oldPlatform,
			);
			const isSameBase = deviceId?.startsWith(persistentDeviceId) || false;
			const isPlatformChanged = oldPlatform !== currentPlatform;

			const registerToken = async (deviceID) => {

				await fetchFcmRegister({
					authorization: jwtToken,
					body: {
						token: fcmToken,
						device_id: deviceID,
					},
				})
					.then(() => {

						Cookies.set("fcm_tkn", fcmToken);
						Cookies.set("device_id", deviceID);

					})
					.catch((err) => {

						console.error("Failed to register FCM token:", err);

					});

			};

			const shouldReRegister = !storedFcmToken
				|| storedFcmToken !== fcmToken
				|| isPlatformChanged
				|| !isSameBase;

			if (shouldReRegister) {

				Cookies.remove("fcm_tkn");
				Cookies.remove("device_id");
				await registerToken(isSameBase ? deviceId : newDeviceId);

			}

		});

	}, []);

	const handlePushMessage = useCallback((messaging) => {

		fcmGetMessage(messaging, (message) => {

			const hasQuestionMark = /\?/.test(message?.data?.deeplink);
			useNotification.getState().addNotification({
				id: `notification-${message.fcmMessageId}`,
				category_notif: message.data.category,
				subcategory_notif: message.data.child_category,
				type_notif: message.data.type,
				notifId: message.data.notif_id,
				body: message.data.message,
				type: "regular",
				title: message.data.title,
				url: `${message?.data?.deeplink}${hasQuestionMark ? "&" : "?"}utm_source=web&utm_medium=web_push&utm_campaign=${message.data.type}`,
				buttonText: "SEE MORE",
			});

		});

	}, []);

	useEffect(() => {

		// check this first firebase support or not
		if (checkLoginStatus() && firebase.messaging.isSupported()) {

			const messaging = firebase.messaging();
			registerFcmToken(messaging);
			handlePushMessage(messaging);

		}

	}, []);

	return <></>;

};

FcmNotification.propTypes = {
	isMobile: PropTypes.bool,
};

FcmNotification.defaultProps = {
	isMobile: false,
};

export default FcmNotification;
